/**
 * Обратная связь (CASE-48). Замечание или предложение функции уходит на
 * сервер вместе с именем экрана; владелец проставляется по cookie-сессии.
 */
import { apiPost } from '../client.js';

export type FeedbackKind = 'remark' | 'idea';

/** Отправить обращение обратной связи. */
export async function submit(
  screen: string,
  kind: FeedbackKind,
  text: string,
): Promise<void> {
  await apiPost<{ id: string }, { screen: string; kind: FeedbackKind; text: string }>(
    '/api/v1/feedback',
    { screen, kind, text },
  );
}
